import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { clearCurrentDocument, clearDocumentsList, setAiSearchChecked, setAiSearchFeatureEnabled, setDocumentsSearchTerm } from '@lib/medical-documents';
import { MemberHubState, resetMemberHubState } from '@lib/members/data-access';
import { resetPrescriptionsState } from '@lib/prescriptions/data-access';
import { Store } from '@ngrx/store';

export const clearMemberProfileGuard: CanDeactivateFn<unknown> = () => {
  const store = inject(Store<MemberHubState>);

  store.dispatch(resetMemberHubState());
  store.dispatch(resetPrescriptionsState());
  store.dispatch(setAiSearchFeatureEnabled({ enabled: false }));
  store.dispatch(setAiSearchChecked({ checked: false }));
  store.dispatch(setDocumentsSearchTerm({ documentsSearchTerm: '' }));
  store.dispatch(clearDocumentsList());
  store.dispatch(clearCurrentDocument());

  return true;
};
